// extracted by mini-css-extract-plugin
export default {"panel":"ConfigPanel_panel__B83Db","tabsHeader":"ConfigPanel_tabsHeader__GLJ-i","content":"ConfigPanel_content__z7+dy","footer":"ConfigPanel_footer__K8AnF"};